import { createFileRoute } from '@tanstack/react-router';

import { PlanBillingPage, planBillingSearchSchema } from '@/pages/settings/plan-billing';

export const Route = createFileRoute('/settings/plan-billing')({
    component: PlanBillingPage,
    validateSearch: planBillingSearchSchema,
});
